var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dog-title-box",style:({marginTop:`${_vm.top}rem`})},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/index/circle-red.webp"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }